<div class="container voiceshot-dialog">
  <h1 mat-dialog-title>Voiceshot Campaign</h1>

  <mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-label>Voiceshot</mat-label>
      <mat-select placeholder="Voiceshot" [(ngModel)]="chosenVoiceshot" name="chosenVoiceshot" (selectionChange)="voiceshotSelected($event?.value)">
        @for (_voiceshot of availableVoiceshots; track _voiceshot) {
          <mat-option [value]="_voiceshot">
            {{ _voiceshot?.title }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (chosenVoiceshot?.filename && sanitizedUrl) {
      <div class="html-audio-preview">
        <audio [src]="sanitizedUrl" controls>
          Your browser does not support the audio element.
        </audio>
      </div>
    }

      @if (recipients?.length) {
        <h4>Recipients:</h4>
        <div class="recipient-list">
          @for (rec of recipients; track rec) {
            <div>{{ rec?.name }} - {{ rec?.phone }}</div>
          }
        </div>
      }
    </mat-dialog-content>

    <div class="row pin-to-bottom">
      <button mat-raised-button color="primary" [disabled]="!chosenVoiceshot || !chosenVoiceshot?.filename" (click)="closeDialog(true)">{{ confirmText }}</button>
      <button mat-button mat-dialog-close (click)="closeDialog(false)">Cancel</button>
    </div>
  </div>